import React from 'react'
import './../Services/service.css'

const directTaxation = () => {
  return (
    <>
    <div className="audit-page">
        <section className="audit-cover direct-tax">
           <div className="container">
              <div className="audit-cover-para">
                <h1 style={{color: "#f1f1f1", fontSize: "42px"}}>DIRECT TAXATION</h1>
              </div>
           </div>
        </section>
        <section className="audit-page-content container" style={{marginBottom: "40px"}}>
           <p>Besides handling all procedural matters relating to filing of returns and representation before tax authorities at all levels, we have been advising our clients on all matters related to Taxation also. We specialize in tax advice for individuals, partnership firms and companies.</p>
           <p><strong>Our services include:</strong></p>
           <p>&#x2022; Preparation and filing of Income-tax of resident and non-resident individuals, domestic and foreign companies, and other entities/clients.</p>
           <p>&#x2022; Corporate and personal tax compliance including income-tax assessments, appeals, representation before Tax Authorities etc.</p>
           <p>&#x2022; Provide advice in Tax Planning for Domestic and foreign clients.</p>
           <p>&#x2022; Tax Planning for Trusts and non-profit making organization.</p>
           <p>&#x2022; Filing of E- TDS Returns.</p>
           <p>&#x2022; Specialised services for existing, returning as well as new NRI’s with substantial interest in business, property, investments & bank accounts in India.</p>
           <p>&#x2022; Providing both Tax Advisory and Litigation Services</p>
           <p>&#x2022; Transfer Pricing Advisory Services.</p>
           <p>&#x2022; Rectification/Revision in any cases.</p>
           <p>&#x2022; Compliance of Income Computation Disclosure Standard (ICDS) requirement.</p>
        </section>
    </div> 
  </>
  )
}

export default directTaxation
